const makeOptions = labels => labels.map((labelKey, index) => ({
  id: String.fromCharCode(97 + index),
  labelKey,
}))

const questions = [
  {
    id: 1,
    questionKey: 'What is the difference between weather and climate?',
    options: makeOptions([
      'Weather is the average over 30 years and climate is the weather conditions outside today.',
      'Weather is the weather conditions now outside today and climate is the long-term average.',
      'Weather is temperature and precipitation, and climate means the average over decades.',
    ]),
    correctOptionId: 'b',
  },
  {
    id: 2,
    questionKey: 'What are the causes of climate change?',
    options: makeOptions([
      'The natural change of seasons between summer and winter.',
      'The increase of greenhouse gases in the atmosphere due to human activities.',
      'The daily rotation of the Earth around the Sun.',
    ]),
    correctOptionId: 'b',
  },
  {
    id: 3,
    questionKey: 'Which action can young people take to help reduce climate change?',
    options: makeOptions([
      'Planting and protecting trees in their community to help absorb CO₂.',
      'Burning household waste to make it disappear more quickly.',
      'Keeping lights and electronic devices on even when they are not in use.',
    ]),
    correctOptionId: 'a',
  },
  {
    id: 4,
    questionKey: 'Which of the following is a consequence of prolonged dry spells caused by climate change?',
    options: makeOptions([
      'Increased freshwater availability.',
      'Improved crop yields.',
      'Reduced soil moisture affecting crop growth.',
    ]),
    correctOptionId: 'c',
  },
  {
    id: 5,
    questionKey: 'What is one possible effect of heavy rains and floods caused by climate change?',
    options: makeOptions([
      'Damage to crops and infrastructure.',
      'Decrease in soil erosion.',
      'Clean roads.',
    ]),
    correctOptionId: 'a',
  },
  {
    id: 6,
    questionKey: 'What is the consequence of human activities on the greenhouse effect?',
    options: makeOptions([
      'They reduce the Earth\'s surface temperature by decreasing the amount of greenhouse gases in the atmosphere.',
      'They increase the amount of greenhouse gases in the atmosphere, which raises Earth’s temperature.',
      'They have no effect on the greenhouse effect or the Earth\'s temperature.',
    ]),
    correctOptionId: 'b',
  },
  {
    id: 7,
    questionKey: 'Which of the following statements is correct?',
    options: makeOptions([
      'Clearing forests, using fertilizers in farming and burning fossil fuels adds additional CO₂ to the atmosphere and intensifies climate change.',
      'Planting trees and using renewable energy increases greenhouse gases in the atmosphere and intensifies climate change.',
      'Human activities cool the planet by reducing greenhouse gas levels naturally.',
    ]),
    correctOptionId: 'a',
  },
  {
    id: 8,
    questionKey: 'What is the difference between a climate hazard and a climate risk?',
    options: makeOptions([
      'A climate hazard is the potential harm to humans, while a climate risk is the extreme weather event itself.',
      'A climate hazard is an extreme weather event or long-term shift, while a climate risk is the potential negative impact on humans or ecosystems when exposed and vulnerable.',
      'A climate hazard is always caused by humans, while a climate risk is always natural.',
    ]),
    correctOptionId: 'b',
  },
  {
    id: 9,
    questionKey: 'What is a mitigation measure to reduce greenhouse gas emissions?',
    options: makeOptions([
      'Using heat resistant crops.',
      'Constructing flood-resistant infrastructure.',
      'Reducing fossil fuel use.',
    ]),
    correctOptionId: 'c',
  },
  {
    id: 10,
    questionKey: 'Which of the following is an example of a climate change adaptation project?',
    options: makeOptions([
      'Installing solar panels in schools.',
      'Building flood defences in villages.',
      'Replacing diesel cars with electric vehicles.',
    ]),
    correctOptionId: 'b',
  },
]

export { questions }
